import { IGetAccessCodeResponse } from 'api/components/Auth/types';

import { AUTH_TOKEN_NAME, AUTH_TOKEN_REFRESH_NAME, AUTH_TOKEN_WELLFUNNEL_NAME } from 'constants/api';

import { getCookie } from 'helpers/cookie';
import { getLocalStorageKey, LS_KEYS } from 'helpers/localStorage';

import { InferValueTypes } from 'types/commonTypes';

import * as action from './actions';
import * as actionTypes from './actionTypes';

export interface AuthState {
    isAuthenticated: boolean;
    isComplete: boolean;
    redirectUrl: string | null;
    token: string | null;
    tokenWellFunnel: string | null;
    tokenRefresh: string | null;
    appAccessCode: IGetAccessCodeResponse | null;
    isAppAccessCodeFailed: boolean;
    authToken: string | null;
}

export const initialState = {
    isAuthenticated: false,
    isComplete: false,
    redirectUrl: null,
    token: getCookie(AUTH_TOKEN_NAME) || null,
    tokenWellFunnel: getCookie(AUTH_TOKEN_WELLFUNNEL_NAME) || null,
    tokenRefresh: getCookie(AUTH_TOKEN_REFRESH_NAME) || null,
    appAccessCode: getLocalStorageKey(LS_KEYS.appAccessCode, null),
    isAppAccessCodeFailed: false,
    authToken: null,
};

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const authReducer = (state: AuthState = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.SIGN_IN_SUCCESS:
            return { ...state, isAuthenticated: true, isComplete: true, redirectUrl: null };

        case actionTypes.SET_AUTHENTICATION_STATUS:
            return { ...state, isComplete: true, isAuthenticated: action.payload };

        case actionTypes.LOG_OUT:
            return { ...state, isAuthenticated: false, isComplete: true };

        case actionTypes.SET_AUTHENTICATION_REDIRECT_URL:
            return { ...state, redirectUrl: action.payload };

        case actionTypes.SET_AUTH_TOKEN_ACCESS:
            return { ...state, token: action.payload };

        case actionTypes.SET_AUTH_TOKEN_WELLFUNNEL:
            return { ...state, tokenWellFunnel: action.payload };

        case actionTypes.SET_AUTH_TOKEN_REFRESH:
            return { ...state, tokenRefresh: action.payload };

        case actionTypes.GET_APP_ACCESS_CODE_SUCCESS:
            return { ...state, appAccessCode: action.payload };

        case actionTypes.GET_APP_ACCESS_CODE_FAILURE:
            return { ...state, isAppAccessCodeFailed: true };

        case actionTypes.GET_AUTH_TOKEN_SUCCESS:
            return { ...state, authToken: action.payload };

        default:
            return state;
    }
};

export default authReducer;
